import { CheckinWidget } from './CheckinWidget';

export function Header({ currentUser, role }) {
    if (role !== 'sdr') return null;

    return (
        <header style={{
            height: 52,
            borderBottom: '1px solid var(--glass-border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '0 1.5rem',
            background: 'var(--surface, var(--orbion-surface, #04091c))',
            flexShrink: 0,
            gap: '0.875rem',
        }}>
            {currentUser?.nome && (
                <span style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)' }}>
                    {currentUser.nome}
                </span>
            )}
            <CheckinWidget currentUser={currentUser} />
        </header>
    );
}
